module.exports = __webpack_public_path__ + "assets/white_edit-8695ee.svg";